"use strict";

exports.__esModule = true;
exports.EditableSurfaceElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _EditableSurfaceItemWrapper = require("./EditableSurfaceItemWrapper");
var _getDecoratedNode = require("../../../Utils/getDecoratedNode");
var _dec, _dec2, _class, _EditableSurfaceElement;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var img = btoa("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" width=\"16\" height=\"16\"><circle cx=\"1\" cy=\"1\" r=\"1\" fill=\"rgba(0, 0, 0, 0.3)\"></circle></svg>");
var widgetTarget = {
  drop: function drop(props, monitor, component) {
    var elementEditor = props.elementEditor;
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var delta = monitor.getDifferenceFromInitialOffset();
      var _monitor$getItem = monitor.getItem(),
        element = _monitor$getItem.element,
        path = _monitor$getItem.path;
      var x = Math.round((element.props.x || 0) + delta.x);
      var y = Math.round((element.props.y || 0) + delta.y);
      var _element$props = element.props,
        width = _element$props.width,
        height = _element$props.height;
      elementEditor.moveElementAt(path, props.path, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    } else if (itemType === "widget") {
      var componentNode = (0, _getDecoratedNode.getDecoratedNode)(component);
      var domNode = (0, _getDecoratedNode.resolveRelativeDropNode)(componentNode, props.path.length);
      if (domNode == null) {
        return;
      }
      var rect = domNode.getBoundingClientRect();
      var _delta = monitor.getSourceClientOffset();
      var _monitor$getItem2 = monitor.getItem(),
        widget = _monitor$getItem2.widget;
      var _x = Math.round(_delta.x - rect.left);
      var _y = Math.round(_delta.y - rect.top);
      var _element = widget.createElement({
        x: _x,
        y: _y
      });
      elementEditor.appendElementAt(props.path, _element);
    }
  }
};
/**
 * Displays an editable surface which can draw children at arbitrary positions.
 */
var EditableSurfaceElement = exports.EditableSurfaceElement = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, _dec2 = (0, _reactDnd.DropTarget)(["widget", "element"], widgetTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec(_class = _dec2(_class = (_EditableSurfaceElement = /*#__PURE__*/function (_Component) {
  function EditableSurfaceElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.node = null;
    _this.setNode = function (el) {
      _this.node = el;
    };
    _this.getNode = function () {
      return _this.node;
    };
    _this.renderChild = function (element, index) {
      var _this$props = _this.props,
        render = _this$props.render,
        path = _this$props.path;
      return /*#__PURE__*/_react["default"].createElement(_EditableSurfaceItemWrapper.EditableSurfaceItemWrapper, {
        path: path.concat("children", index),
        element: element,
        x: element.props.x,
        y: element.props.y,
        width: element.props.width,
        height: element.props.height
      }, render(element, index));
    };
    return _this;
  }
  _inheritsLoose(EditableSurfaceElement, _Component);
  var _proto = EditableSurfaceElement.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      connectDropTarget = _this$props2.connectDropTarget,
      children = _this$props2.children;
    return connectDropTarget(/*#__PURE__*/_react["default"].createElement("div", {
      ref: this.setNode,
      style: {
        width: width,
        height: height,
        background: "url(\"data:image/svg+xml;base64," + img + "\") repeat -1px 0px",
        backgroundColor: "white"
      },
      "data-position": "relative"
    }, children.map(this.renderChild)));
  };
  return EditableSurfaceElement;
}(_react.Component), _EditableSurfaceElement.defaultProps = {
  width: 1024,
  height: 768,
  elementEditor: undefined
}, _EditableSurfaceElement)) || _class) || _class);